import React from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../assets/background.jpg"; // Placeholder for background image
import fonepayLogo from "../assets/fonepay.png";
import paymentImage from "../assets/payment.png";
import { FaWhatsapp } from "react-icons/fa";

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen text-white"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#1e3a8a",
        background: `linear-gradient(135deg, rgba(30, 58, 138, 0.8), rgba(6, 182, 212, 0.8)), url(${backgroundImage})`,
      }}
    >
      {/* Hero Banner */}
      <div className="bg-black/30 backdrop-blur-sm text-white py-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 animate-fade-in">
            About Virtueista IT
            <span className="block text-yellow-500 mt-2">
              Innovate. Learn. Succeed.
            </span>
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto mb-6">
            Empowering businesses with cutting-edge software solutions and
            preparing individuals for thriving tech careers in Biratnagar,
            Nepal.
          </p>
          <button
            onClick={() => navigate("/send-inquiry")}
            className="bg-yellow-500 text-blue-900 py-3 px-6 rounded-md font-semibold hover:bg-yellow-600 transform hover:scale-105 transition-all duration-300 shadow-md"
          >
            Get in Touch
          </button>
        </div>
      </div>

      {/* Company Overview */}
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-16 bg-gray-50 rounded-xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
            Who We Are
          </h2>
          <p className="text-gray-600 mt-4 max-w-3xl mx-auto">
            Welcome to Virtueista IT, a dynamic software development and IT
            training company based in Biratnagar, Nepal. We are passionate about
            transforming businesses through innovative digital solutions and
            equipping individuals with industry-ready skills for successful tech
            careers.
          </p>
        </div>

        {/* Services Section */}
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-8">
            Our Software Solutions
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: "Custom Software",
                description:
                  "Tailored software solutions designed to streamline your business operations and drive growth.",
                icon: "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
              },
              {
                title: "Web & Mobile Apps",
                description:
                  "Responsive web applications and user-friendly mobile apps built to engage your audience.",
                icon: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 4l-6 5-6-5V4l6 5 6-5v2z",
              },
              {
                title: "Digital Platforms",
                description:
                  "Scalable platforms to enhance your online presence and meet your business goals.",
                icon: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15h2v-2H8v2zm0-4h2V9H8v2zm0-4h2V5H8v2z",
              },
            ].map((service, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm p-6 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300"
              >
                <svg
                  className="w-10 h-10 text-blue-600 mb-4"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d={service.icon} />
                </svg>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Training Programs Section */}
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-8">
            Our Training Programs
          </h2>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-8">
            Our professional IT courses bridge the gap between academic learning
            and industry demands, perfect for SEE graduates, college students,
            and job seekers.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {[
              {
                title: "Web Development",
                description:
                  "Master HTML, CSS, and JavaScript to build modern, responsive websites.",
              },
              {
                title: "Python Programming",
                description:
                  "Learn Python and create games or automate tasks with hands-on projects.",
              },
              {
                title: "MERN Stack Development",
                description:
                  "Build full-stack web apps using MongoDB, Express, React, and Node.js.",
              },
              {
                title: "Data Science & ML",
                description:
                  "Analyze data and build machine learning models with Python.",
              },
              {
                title: "Digital Marketing & SEO",
                description:
                  "Grow online presence with effective marketing and SEO strategies.",
              },
            ].map((course, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm p-6 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300"
              >
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {course.title}
                </h3>
                <p className="text-gray-600">{course.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Location Section with Google Map */}
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-8 animate-fade-in">
            Visit Us in Biratnagar
          </h2>
          <p className="text-lg text-gray-600 text-center max-w-3xl mx-auto mb-8">
            Find us at Traffic Chowk -10, Biratnagar, Nepal, where we’re shaping
            the future of IT education and software development.
          </p>
          <div className="max-w-7xl mx-auto">
            {/* Google Map */}
            <div className="w-full bg-white rounded-lg shadow-xl overflow-hidden transform hover:shadow-2xl transition-shadow duration-300">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3569.496389714512!2d87.26951261503227!3d26.454218983320536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ef744d5b7f4c2b%3A0x4b8f4e2c6c4d4e4f!2sTraffic%20Chowk%2C%20Biratnagar%2C%20Nepal!5e0!3m2!1sen!2snp!4v1698765432109!5m2!1sen!2snp"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Virtueista IT Location - Traffic Chowk, Biratnagar"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Payment Options Section */}
        <div className="py-12 px-4 max-w-7xl mx-auto">
          {/* Heading and Description */}
          <h2 className="text-3xl md:text-4xl font-bold text-blue-800 text-center mb-4">
            Our Payment Options
          </h2>
          <p className="text-lg text-gray-600 text-center max-w-3xl mx-auto mb-8">
            We have made available the following payment options for easiest
            transactions. Please feel free to use any one per your choice.
          </p>

          {/* Payment Options Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 bg-white/10 backdrop-blur-sm p-6 rounded-lg shadow-lg transform hover:shadow-xl transition-shadow duration-300">
            {/* Pay via Fonepay */}
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <img
                  src={fonepayLogo}
                  alt="Fonepay Logo"
                  className="h-6 px-1 bg-white"
                />
                <h3 className="text-xl font-semibold text-red-500">
                  Pay via Fonepay
                </h3>
              </div>
              <img
                src={paymentImage}
                alt="Payment Instructions"
                className="w-full max-w-xs mx-auto"
              />
              <div className="flex justify-center">
                <button className="bg-red-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-red-600 transition-all duration-300">
                  Open your Fonepay Mobile, Internet Banking App, Digital Wallet (Khalti, UnionPay)
                </button>
              </div>
            </div>

            {/* Pay via Bank Transfer */}
            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-red-500">
                Pay via Bank Transfer
              </h3>
              <p className="text-gray-600">
                In order to pay via Bank Transfer, Virtueista I.T. Private Limited has the
                following banks:
              </p>
              <div className="flex items-center space-x-2 bg-gray-200 p-2 rounded-md">
                <div className="w-12 h-12 rounded flex items-center justify-center">
                  <span className="text-blue-500 font-semibold">Bank</span>
                </div>
                <span className="text-blue-500 font-semibold">Transfer</span>
              </div>
              <div className="space-y-1">
                <h4 className="font-semibold text-gray-800">Siddhartha Bank Details:</h4>
                <p className="text-gray-600">
                  <span className="font-medium">Bank Name:</span> Siddhartha Bank Ltd.
                </p>
                <p className="text-gray-600">
                  <span className="font-medium">Account Name:</span> Virtueista I.T. Private Limited
                </p>
                <p className="text-gray-600">
                  <span className="font-medium">Account Number:</span> 2222050018297245
                </p>
                <p className="text-gray-600">
                  <span className="font-medium">Branch:</span> Mahendra Chowk
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center bg-black/30 backdrop-blur-sm text-white py-12 px-4 rounded-xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Transform Your Future?
          </h2>
          <p className="text-lg max-w-2xl mx-auto mb-6">
            Whether you need a modern software solution or want to upgrade your
            tech skills, Virtueista IT is your trusted partner in Biratnagar and
            beyond.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button
              onClick={() => navigate("/send-inquiry")}
              className="bg-yellow-500 text-blue-900 py-3 px-6 rounded-md font-semibold hover:bg-yellow-600 transition-all duration-300"
            >
              Contact Us
            </button>
            <button
              onClick={() => navigate("/courses")}
              className="bg-white text-blue-800 py-3 px-6 rounded-md font-semibold hover:bg-gray-100 transition-all duration-300"
            >
              Explore Courses
            </button>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9779849489441"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 animate-spin-slow" />
      </a>

      {/* Inline CSS for Animations */}
      <style>
        {`
          @keyframes fade-in {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in {
            animation: fade-in 1s ease-out;
          }
          .hover\\:scale-105:hover {
            transform: scale(1.05);
          }
          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spin-slow 4s linear infinite;
          }
          @media (max-width: 640px) {
            div[style*="background-attachment: fixed"] {
              background-attachment: scroll;
            }
          }
        `}
      </style>
    </div>
  );
};

export default AboutUs;
